import { useState } from "react";
import Input from "../../component/items/Input";
import Button from "../../component/items/Button";
import Header from "../../component/items/Header";
import { dataPost } from "../../network";
import { Dialog } from "../../component/items/Dialog";
import { dialogDataTypes } from "../../component/items/itemDataType";
import { useNavigate } from "react-router-dom";
import { forgotPasswordUrl } from "../../network/const";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [dialog, setDialog] = useState(false);
  const [dialogData, setDialogData] = useState({
    title: "",
    description: "",
    btnText: "",
  });
  const navigate = useNavigate();

  const handleChange = (e: any) => setEmail(e.target.value);

  const dialogInit = ({ title, btnText, description }: dialogDataTypes) => {
    setDialogData({ title, btnText, description });
    setDialog(true);
  };

  const submit = async (e: Event) => {
    e.preventDefault();
    if (!email) {
      dialogInit({
        title: "Validation Error",
        description: "Email is required",
        btnText: "OK",
      });
      return;
    }

    const res = await dataPost(forgotPasswordUrl, { email }, { silent: false });

    if (res.status) {
      navigate("/reset-password", {
        state: {
          token: res.data.token,
          email,
          expireInSeconds: res.data.expireInSeconds,
        },
      });
    } else {
      dialogInit({ title: "Error", description: res.message, btnText: "OK" });
    }
  };

  return (
    <div className="flex justify-center items-center h-screen">
      <div className="max-w-md w-full space-y-8">
        <Header
          heading="Forgot Password"
          paragraph="Go back to "
          linkName="Login"
          linkUrl="/login"
        />
        <form className="mt-8 space-y-6">
          <Input
            key="email"
            id="email"
            labelText="Email address"
            labelFor="email"
            type="email"
            name="email"
            placeholder="Email address"
            isRequired={true}
            value={email}
            handleChange={handleChange}
            customClass={""}
          />
          <Button text="Send OTP" action="button" handleSubmit={submit} />
        </form>
        <Dialog
          open={dialog}
          handleOpen={() => setDialog(!dialog)}
          title={dialogData.title}
          description={dialogData.description}
          buttonText={dialogData.btnText}
        />
      </div>
    </div>
  );
}

export default ForgotPassword;
